var exports = {
  "i": "xb99ab02a--9bb582--wrapper",
};

module.exports = exports;
